import { useEffect, useCallback } from 'react';

import logFacebookPixel from '../logFacebookPixel';
import { Params } from '../types';

const useFbPixelByProduct = (params: Params) => {
  const fbPixelClickReservation = useCallback(() => {
    logFacebookPixel('track', 'InitiateCheckout', params);
  }, [params]);

  useEffect(() => {
    if (params.content_ids?.length > 0 && params.content_ids[0]) {
      logFacebookPixel('track', 'ViewContent', params);
    }
  }, [params]);

  return { fbPixelClickReservation };
};

export default useFbPixelByProduct;
